import { useTranslation } from 'react-i18next';
import type { Message } from '@/types/api';
import { stripMarkdown } from '@/lib/markdown';
import { CloseIcon, ReplyIcon } from '@/components/icons';

/** Keep the reply context visible while composing, with a single cancel target. */
export function ReplyPreviewBar(props: { replyingTo: Message; onCancelReply: () => void }) {
  const { t } = useTranslation();
  const plain = stripMarkdown(props.replyingTo.content);
  return (
    <div
      className="studio-reply-draft mb-1 flex overflow-hidden rounded-lg"
      style={{
        backgroundColor: 'rgb(var(--surface-card) / 0.6)',
        backdropFilter: 'blur(6px) saturate(140%)',
        WebkitBackdropFilter: 'blur(6px) saturate(140%)',
        boxShadow: 'inset 0 0 0 1px rgb(var(--ring-inset) / var(--ring-inset-alpha))',
      }}
    >
      <div className="w-[3px] shrink-0" style={{ backgroundColor: 'rgb(var(--bk-accent))' }} />
      <div className="flex min-w-0 flex-1 items-center gap-2 px-3 py-1.5 text-xs">
        <ReplyIcon className="h-4 w-4 shrink-0 text-accent" />
        <div className="min-w-0 flex-1">
          <span className="text-ink-muted">{t('composer.replyPrefix')}</span>
          <span className="font-light tracking-[-0.02em] text-accent">
            {props.replyingTo.author.displayName || props.replyingTo.author.username}
          </span>
          <span className="text-ink-muted">: </span>
          <span className="text-ink-dim">
            {plain.length > 120 ? plain.slice(0, 120) + '…' : plain}
          </span>
        </div>
          <button
            type="button"
            onClick={props.onCancelReply}
            aria-label={t('composer.cancelReply')}
            title={t('composer.cancelReply')}
            className="shrink-0 rounded p-1 text-ink-muted transition-colors hover:bg-white/10 hover:text-ink"
          >
            <CloseIcon className="h-3.5 w-3.5" />
          </button>
      </div>
    </div>
  );
}
